import {
  GENERATE_PDF_URI,
  LOADING_PDF,
  DOWNLOADING_PDF,
  DONE_GENERATING_PDF,
  CLEAR_PDF_DATA
} from "./types";
import { getFormStatus } from "../utils/api";
import jspdf from "jspdf";
import { notification } from "antd";

export const generatePDF = (formNumber, download) => dispatch => {
  if (download) {
    dispatch(setDownloadingPdf());
  } else {
    dispatch(setLoadingPdf());
  }

  getFormStatus(formNumber)
    .then(res => {
      const form = res.data;
      const returnFormattedDate = date => {
        let dateSplit = date.split("-");
        return `${dateSplit[0]} ${dateSplit[1]}, ${dateSplit[2].split(" ")[0]}`;
      };

      let doc = new jspdf("p", "mm", "a4");
      let logo = new Image();

      toDataURL("/assets/img/hcdelogo.png").then(dataUri => {
        logo.src = dataUri;

        doc.addImage(logo, "PNG", 55, 20, 0, 0);

        doc.setFontSize(20);
        doc.text("Federal Grant/Contract Salary Reporting", 43, 65);

        doc.setFontSize(14);
        doc.text("Time and Effort Certification", 77, 72);

        doc.setFontSize(14);
        doc.setFontStyle("bold");
        doc.text("DIVISION:", 10, 98);
        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(`${form.data["Division"]}`, 37, 98);

        doc.setFontSize(14);
        doc.setFontStyle("bold");
        doc.text("AWARD GRANT PERIOD:", 10, 106);
        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(`${form.data["Grant Award Period"]}`, 73, 106);

        doc.setFontSize(14);
        doc.setFontStyle("bold");
        doc.text("NOGA ID #:", 10, 114);
        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(`${form.data["NOGA ID"]}`, 40, 114);

        doc.setFontSize(14);
        doc.setFontStyle("italic");
        doc.text("PROCEDURE:", 10, 130);

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(
          "A. Responsibility for timely completion of this form",
          15,
          135
        );
        doc.text(
          "B. T & E Certification must be completed following the close of each month by the last working day of each month",
          15,
          140
        );
        doc.text(
          "C. T & E reporting will be kept on file in the division along with grant/contract records",
          15,
          145
        );
        doc.text(
          "D. Following completion of the grant period, T & E records must be retained according to program specifications",
          15,
          150
        );

        doc.setFontStyle("bold");
        doc.text(
          "By authority of 2 CFR 200, Subpart E, Cost Principles, the purpose of this Certification is to provide reasonable",
          10,
          165
        );
        doc.text(
          "assurance that work performed is commensurate with salary charged to the grant/contract budget.",
          18,
          170
        );

        let yStatement = 180;
        form.approvals.forEach((approval, index) => {
          let signature = new Image();

          const getTitleFromApprovingAuthority = approvingAuthority => {
            const approver = approvingAuthority.split("_");

            if (approver.includes("employee")) {
              return {
                statement: "EMPLOYEE STATEMENT",
                title: "Employee"
              };
            } else if (
              approver.includes("manager") &&
              !approver.includes("director")
            ) {
              return {
                statement: "MANAGER STATEMENT",
                title: "Manager"
              };
            } else if (
              approver.includes("assistant") &&
              approver.includes("director")
            ) {
              return {
                statement: "ASSISTANT DIRECTOR",
                title: "Assistant Director"
              };
            } else if (approver.includes("director")) {
              return {
                statement: "DIRECTOR STATEMENT",
                title: "Director"
              };
            } else if (approver.includes("elt")) {
              return {
                statement: "ELT MEMBER STATEMENT",
                title: "ELT Member"
              };
            }
          };

          doc.setFontSize(12);
          doc.setFontStyle("bold");
          doc.text(
            `(${index + 1}) ${
              getTitleFromApprovingAuthority(approval["approvingAuthority"])
                .statement
            }`,
            10,
            yStatement
          );

          doc.setFontSize(10);
          doc.setFontStyle("normal");

          if (index <= 0) {
            doc.text(
              `I, ${
                approval["name"]
              } understand and certify that 100% of my duties`,
              70,
              yStatement
            );
            doc.text(
              `and responsibilites are performed for the Adult Ed Grants as allocated by adult education classes.`,
              15,
              yStatement + 5
            );
          } else {
            doc.text(
              `I, ${approval["name"]} certify that 100% of his/her duties`,
              70,
              yStatement
            );
            doc.text(
              "and responsibilities are performed for the Adult Ed grants as allocated by adult education classes",
              15,
              yStatement + 5
            );
          }

          doc.text("Signature: ", 10, yStatement + 15);
          signature.src = form["files"][index].data;
          doc.addImage(signature, "PNG", 25, yStatement - 20, 50, 55);

          doc.text("Date:", 10, yStatement + 20);
          doc.text(
            `${returnFormattedDate(form["formSubmissionTimeStamp"])}`,
            20,
            yStatement + 20
          );

          doc.text(
            `Position: ${
              getTitleFromApprovingAuthority(approval["approvingAuthority"])
                .title
            }`,
            10,
            yStatement + 25
          );

          yStatement += 45;
        });

        if (download) {
          doc.save(formNumber);
          dispatch(clearPdfData());
        } else {
          dispatch({
            type: GENERATE_PDF_URI,
            payload: {
              uri: doc.output("datauristring"),
              form: form
            }
          });

          dispatch({
            type: DONE_GENERATING_PDF
          });
        }
      });
    })
    .catch(err => {
      dispatch(clearPdfData());
      notification.error({
        message: "Error!",
        description:
          err.response.data.message || "Something went wrong! Please try again"
      });
    });
};

export const setLoadingPdf = () => {
  return {
    type: LOADING_PDF
  };
};

export const setDownloadingPdf = () => {
  return {
    type: DOWNLOADING_PDF
  };
};

export const setPdfData = data => {
  return {
    type: GENERATE_PDF_URI,
    payload: data
  };
};

export const doneGeneratingPdf = () => {
  return {
    type: DONE_GENERATING_PDF
  };
};

export const clearPdfData = () => {
  return {
    type: CLEAR_PDF_DATA
  };
};

const toDataURL = url =>
  fetch(url)
    .then(response => response.blob())
    .then(
      blob =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
